export const PLAN_STAY = "/plan-stay";
export const CHOOSE_ROOM = "/choose-room";
export const CHOOSE_ROOM_NUMBER = "/choose-room-number";
export const SELECT_DINING_TIMES = "/select-dining-times";
export const SELECT_ENTERTAINMENT = "/select-entertainment";
export const SELECT_ADDONS = "/select-addons";
export const CHECKOUT = "/checkout";
export const SUMMARY = "/summary";
